import { takeEvery } from "redux-saga/effects";

import { BillingDocumentAction } from "actions";

import { INTEREST_PREVIEW } from "constants/actionTypes";

import { getBillingDocuments, getInterestPreviewById } from "selectors";

import { fetchMissingByIdFactory } from "./lib";

export const fetchMissingBillingDocuments = fetchMissingByIdFactory(
  getInterestPreviewById,
  getBillingDocuments,
  interestPreview => interestPreview.billingDocumentId,
  billingDocumentIds =>
    BillingDocumentAction.requestSome({ billingDocumentIds }),
);

export default function* interestPreviewSaga() {
  yield takeEvery(
    INTEREST_PREVIEW.FETCH_BULK.SUCCESS,
    fetchMissingBillingDocuments,
  );
}
